module.exports = __webpack_public_path__ + "2f1ac0635a07a48d717f4581540efa2f.jpg";